"use client";

import type { SupSingleVaultV3 } from "@/types";
import React from "react";

import { getEmptyLabel } from "@/components/Ui/Label/Apy";
import UiLabelRewardsTag from "@/components/Ui/Label/Rewards/Tag";
import UiDetailsSingleStat from "@/components/Ui/Details/SingleStat";
import { formatCurrencyCompact, getVaultApy, getVaultSharpe, getVaultTvl } from "@/utils";
import config from "@/../config/dapp.config";

interface VaultDetailsStatsProps {
  singleVault: SupSingleVaultV3;
}

export default function VaultDetailsStats({ singleVault }: VaultDetailsStatsProps) {
  return (
    <div className="flex flex-1 flex-col items-stretch justify-end gap-4 md:flex-row md:items-center md:justify-stretch xl:items-end">
      <UiDetailsSingleStat label="Vault TVL" value={getVaultTvl(singleVault)} formatter={formatCurrencyCompact} />
      <UiDetailsSingleStat
        label="Vault APY"
        value={getVaultApy(singleVault)}
        forceFormatter
        formatter={value =>
          (singleVault.rewards?.length ?? 0) > 0 ? (
            <UiLabelRewardsTag useFallback unwrapped vault={singleVault} iconClass="w-8 h-8" />
          ) : value !== -1000000 ? (
            `${value.toFixed(config.decimalsApyRoundingLimit)}%`
          ) : (
            getEmptyLabel(singleVault, "month")
          )
        }
      />
      <UiDetailsSingleStat label="Vault Sharpe" value={getVaultSharpe(singleVault)} placeholder="New" />
    </div>
  );
}
